import * as React from 'react';
import { alpha } from '@mui/material';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
// import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
// import TextField from '@mui/material/TextField';
import { ToastContainer, toast, Slide } from 'react-toastify';
// import categories from '../data/categories.json';
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import {
  TextField,
  Button,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
// import { Label } from '@mui/icons-material';
// import { FormControl, useFormControlContext } from '@mui/base/FormControl';
import { styled } from '@mui/system';
import apiService from '../providers/ApiService';

export default function CaseForm() {
  const { state } = useLocation();
  const editCase = state ? state.case : undefined;
  // console.log('editable2', state.case);
  const [formData, setFormData] = React.useState({
    category: editCase ? editCase.categoryId : '',
    tier: editCase ? editCase.tier : null,
    title: editCase ? editCase.title : '',
    anonymousTitle: editCase ? editCase.anonymousTitle : '',
    // Doctor Notes
    doctor: {
      image: editCase ? editCase.doctor.image : '',
      name: editCase ? editCase.doctor.name : '',
      age: editCase ? editCase.doctor.age : '',
      PMHX: editCase ? editCase.doctor.PMHX : '',
      medicationHistory: editCase ? editCase.doctor.medicationHistory : '',
      medicalNotes: editCase ? editCase.doctor.medicalNotes : '',
      results: editCase ? editCase.doctor.results : '',
      caseDetails: editCase ? editCase.doctor.caseDetails : ''
      // image: null, // the file object
      // imagePreview: '' // for displaying a preview
    },

    // Patient Notes
    patient: {
      background: editCase ? editCase.patient.background : '',
      name: editCase ? editCase.patient.name : '',
      age: editCase ? editCase.patient.age : '',
      caseBackground: editCase ? editCase.patient.caseBackground : '',
      presentingComplaint: editCase ? editCase.patient.presentingComplaint : '',
      openHistory: editCase ? editCase.patient.openHistory : '',
      positiveSX: editCase ? editCase.patient.positiveSX : '',
      negativeSX: editCase ? editCase.patient.negativeSX : '',
      ideas: editCase ? editCase.patient.ideas : '',
      concerns: editCase ? editCase.patient.concerns : '',
      expectations: editCase ? editCase.patient.expectations : '',
      pastMedicalHistory: editCase ? editCase.patient.pastMedicalHistory : '',
      medications: editCase ? editCase.patient.medications : '',
      socialHistory: editCase ? editCase.patient.socialHistory : '',
      familyHistory: editCase ? editCase.patient.familyHistory : '',
      behaviour: editCase ? editCase.patient.behaviour : ''
    },

    // Marking
    marking: {
      positiveIndicatorsGathering: editCase ? editCase.marking.positiveIndicatorsGathering : '',
      negativeIndicatorsGathering: editCase ? editCase.marking.negativeIndicatorsGathering : '',
      positiveIndicatorsManagement: editCase ? editCase.marking.positiveIndicatorsManagement : '',
      negativeIndicatorsManagement: editCase ? editCase.marking.negativeIndicatorsManagement : '',
      positiveIndicatorsRelating: editCase ? editCase.marking.positiveIndicatorsRelating : '',
      negativeIndicatorsRelating: editCase ? editCase.marking.negativeIndicatorsRelating : ''
    },

    // // Key Issues
    // keyIssues: editCase ? editCase.keyIssues : '',

    // Management
    management: {
      managementOfCase: editCase ? editCase.management.managementOfCase : '',
      managementOfDisease: editCase ? editCase.management.managementOfDisease : '',
      relation: editCase ? editCase.management.relation : '',
      adviceToPatients: editCase ? editCase.management.adviceToPatients : '',
      safetyNet: editCase ? editCase.management.safetyNet : '',
      furtherReading: editCase ? editCase.management.furtherReading : ''
    }
  });

  // Handle form field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split('.');
    const updatedFormData = { ...formData };
    keys.reduce((acc, key, index) => {
      if (index === keys.length - 1) {
        acc[key] = value;
      } else {
        if (!acc[key]) acc[key] = {}; // Initialize if it doesn't exist
        return acc[key];
      }
    }, updatedFormData);
    setFormData(updatedFormData);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle the form submission (e.g., send to an API)
    console.log('Form data submitted:', formData);
    if (editCase) {
      // submitCaseData();
      console.log('editing');
      submitEditData();
    } else {
      console.log('creating');
      submitCaseData();
    }
  };

  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       setFormData((prev) => ({
  //         ...prev,
  //         doctor: {
  //           ...prev.doctor,
  //           image: file,
  //           imagePreview: reader.result
  //         }
  //       }));
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  const submitEditData = async () => {
    try {
      const data = await apiService.put(`/cases/${editCase.caseId}`, formData);

      console.log('Case updated successfully:', data);
      toast.success('Case updated');
      // Optional: reset form or show success message
    } catch (error) {
      console.error('Failed to update case:', error);
      toast.error('Failed to update case');
    }
  };

  const submitCaseData = async () => {
    try {
      const data = await apiService.post('/cases', formData);

      console.log('Case created successfully:', data);
      toast.success('Case Created');
      // Optional: reset form or show success message
    } catch (error) {
      console.error('Error creating case:', error);
      toast.error('Failed to create case');
    }
  };
  return (
    <Box
      id="caseForm"
      sx={(theme) => ({
        width: '100%',
        backgroundImage:
          theme.palette.mode === 'light'
            ? 'linear-gradient(180deg, #85BEFA, #FFF)'
            : `linear-gradient(#033668, ${alpha('#090E10', 0.0)})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat'
      })}>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 4, sm: 8 },
          pb: { xs: 6, sm: 10 }
        }}>
        <Stack spacing={2} useFlexGap sx={{ width: { xs: '100%', sm: '80%' } }}>
          {/* <Typography
            variant="h3"
            sx={{
              // display: 'flex',
              // flexDirection: { xs: 'column', md: 'row' },
              alignSelf: 'center',
              textAlign: 'center',
              fontSize: 'clamp(3.5rem, 10vw, 4rem)'
            }}>
            Create a New Case &nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={{
                fontSize: 'clamp(3rem, 10vw, 4rem)',
                color: (theme) => (theme.palette.mode === 'light' ? 'primary.main' : 'primary.main')
              }}>
              {' '}
            </Typography>
          </Typography> */}

          <Box
            component="form"
            sx={{ width: '100%', px: { xs: 2, sm: 0 }, pt: { xs: 8, sm: 8 } }}
            onSubmit={handleSubmit}>
            <Typography variant="h4" align="center">
              Case Form
            </Typography>

            {/* <FormControl
              defaultValue="doctor.name"
              required
              name="doctor.name"
              value={formData.doctor.name}
              onChange={handleChange}
              fullWidth>
              <Label>Name</Label>
              <StyledInput placeholder="Write your name here" />
              <HelperText />
            </FormControl> */}

            <Divider sx={{ my: 2 }} />
            <FormControl fullWidth required>
              <InputLabel id="category-label">Category</InputLabel>
              <StyledSelect
                labelId="category-label"
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                label="Category" // Label to show
              >
                {/* Replace the values below with your actual categories */}
                <MenuItem value="0d98d02b-0cb9-4849-9485-d7e11662bbb9">
                  Patient &lt;19 Years Old
                </MenuItem>
                <MenuItem value="24ab7bdd-6ba8-43fa-be8b-9794b4ec9d59">
                  ⁠Gender and sexual health, including women’s, men’s, and LBTQ
                </MenuItem>
                <MenuItem value="2122607b-cd24-453a-82a2-5f4183f561bf">
                  ⁠Long term conditions, including cancer, multi-morbidity, and disability
                </MenuItem>
                <MenuItem value="55d595c3-737b-4252-b232-623c6c037f0c">
                  Older adults, including frailty and end of life care
                </MenuItem>
                <MenuItem value="856b7eac-fd91-4f57-a38c-3b5b265160e0">
                  ⁠Mental health, including addition, alcohol and substance misuse
                </MenuItem>
                <MenuItem value="fa323b19-9485-47ad-a564-22b38c21a40e">
                  ⁠Urgent and unscheduled care
                </MenuItem>
                <MenuItem value="dd79789a-daa3-4e77-bf4a-8b20b8a365d1">
                  ⁠Health disadvantages and vulnerabilities, including veterans, mental capacity,
                  safeguarding, and communication difficulties
                </MenuItem>
                <MenuItem value="57d9d54b-14ba-419e-ba08-3ad03f2a33b6">
                  ⁠Ethnics, culture, diversity, and inclusivity
                </MenuItem>
                <MenuItem value="55d860e6-f09e-41ca-950d-6fad4b006c23">
                  New presentation of undifferentiated disease
                </MenuItem>
                <MenuItem value="8f1e602d-da2e-428d-b358-8b287513f54a">Prescribing</MenuItem>
                <MenuItem value="82d2c7b2-8b07-414d-a158-805575d31f9e">
                  Investigations and results
                </MenuItem>
                <MenuItem value="5b9e473b-de80-4e3d-a42e-3a5c9108da93">
                  ⁠Professional conversations and dilemmas
                </MenuItem>
              </StyledSelect>
            </FormControl>
            <FormControl fullWidth required>
              <InputLabel id="tier-label">Tier</InputLabel>
              <StyledSelect
                labelId="tier-label"
                id="tier"
                name="tier"
                value={formData.tier}
                onChange={handleChange}
                label="Tier" // Label to show
              >
                {/* Replace the values below with your actual categories */}
                <MenuItem value={1}>Tier 1</MenuItem>
                <MenuItem value={2}>Tier 2</MenuItem>
                <MenuItem value={3}>Tier 3</MenuItem>
              </StyledSelect>
            </FormControl>
            <StyledTextField
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Anonymous Title"
              name="anonymousTitle"
              value={formData.anonymousTitle}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />
            <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Doctor Notes</Typography>

            <StyledTextField
              label="Image URL"
              name="doctor.image"
              value={formData.doctor.image}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />

            {/* <Typography variant="h6" sx={{ mt: 3 }}>
              Upload Image
            </Typography> */}
            {/* <Button variant="contained" component="label">
              Choose File
              <input
                type="file"
                accept="image/*"
                hidden
                name="doctor.image"
                onChange={handleImageChange}
              />
            </Button>

            {formData.doctor.imagePreview && (
              <Box mt={2}>
                <img
                  src={formData.doctor.imagePreview}
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: 200 }}
                />
              </Box>
            )} */}

            <StyledTextField
              label="Name"
              name="doctor.name"
              value={formData.doctor.name}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Age"
              name="doctor.age"
              value={formData.doctor.age}
              onChange={handleChange}
              fullWidth
              // required
            />
            <StyledTextField
              label="PMHX"
              name="doctor.PMHX"
              value={formData.doctor.PMHX}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Medication History"
              name="doctor.medicationHistory"
              value={formData.doctor.medicationHistory}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Medical Notes / Previous Consultations"
              name="doctor.medicalNotes"
              value={formData.doctor.medicalNotes}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Results"
              name="doctor.results"
              value={formData.doctor.results}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Case Details"
              name="doctor.caseDetails"
              value={formData.doctor.caseDetails}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />

            <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Actor (Patient Notes)</Typography>
            <StyledTextField
              label="Background"
              name="patient.background"
              value={formData.patient.background}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Name"
              name="patient.name"
              value={formData.patient.name}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Age"
              name="patient.age"
              value={formData.patient.age}
              onChange={handleChange}
              fullWidth
              // required
              // multiline
              // minRows={3} // Set the minimum number of rows
              // maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Background Information for Case"
              name="patient.caseBackground"
              value={formData.patient.caseBackground}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Presenting Complaint"
              name="patient.presentingComplaint"
              value={formData.patient.presentingComplaint}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Open History"
              name="patient.openHistory"
              value={formData.patient.openHistory}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Positive SX"
              name="patient.positiveSX"
              value={formData.patient.positiveSX}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Negative SX"
              name="patient.negativeSX"
              value={formData.patient.negativeSX}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Ideas"
              name="patient.ideas"
              value={formData.patient.ideas}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Concerns"
              name="patient.concerns"
              value={formData.patient.concerns}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Expectations"
              name="patient.expectations"
              value={formData.patient.expectations}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Past Medical History"
              name="patient.pastMedicalHistory"
              value={formData.patient.pastMedicalHistory}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Medications"
              name="patient.medications"
              value={formData.patient.medications}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Social History (Sexual, Substance, Alcohol, smoking, Occupation, Home life ) "
              name="patient.socialHistory"
              value={formData.patient.socialHistory}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Family History"
              name="patient.familyHistory"
              value={formData.patient.familyHistory}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Behaviour During Consultation"
              name="patient.behaviour"
              value={formData.patient.behaviour}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />

            <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Marking</Typography>
            <Typography variant="subtitle1">Data Gathering & Approach</Typography>
            <StyledTextField
              label="Positive Indicators"
              name="marking.positiveIndicatorsGathering"
              value={formData.marking.positiveIndicatorsGathering}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />
            <StyledTextField
              label="Negative Indicators"
              name="marking.negativeIndicatorsGathering"
              value={formData.marking.negativeIndicatorsGathering}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />

            <Typography variant="subtitle1">Clinical Management & Medical Complexity</Typography>
            <StyledTextField
              label="Positive Indicators"
              name="marking.positiveIndicatorsManagement"
              value={formData.marking.positiveIndicatorsManagement}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />
            <StyledTextField
              label="Negative Indicators"
              name="marking.negativeIndicatorsManagement"
              value={formData.marking.negativeIndicatorsManagement}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />

            <Typography variant="subtitle1">Relating to Others</Typography>
            <StyledTextField
              label="Positive Indicators"
              name="marking.positiveIndicatorsRelating"
              value={formData.marking.positiveIndicatorsRelating}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />
            <StyledTextField
              label="Negative Indicators"
              name="marking.negativeIndicatorsRelating"
              value={formData.marking.negativeIndicatorsRelating}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
              // required
            />

            {/* <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Key Issues</Typography>
            <StyledTextField
              label="Key Issues"
              name="keyIssues"
              value={formData.keyIssues}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            /> */}

            <Divider sx={{ my: 2 }} />
            <Typography variant="h6">Management</Typography>
            <StyledTextField
              label="Management of Case"
              name="management.managementOfCase"
              value={formData.management.managementOfCase}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Management of Disease"
              name="management.managementOfDisease"
              value={formData.management.managementOfDisease}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="In Relation to Our Case"
              name="management.relation"
              value={formData.management.relation}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Advice to Give Patients"
              name="management.adviceToPatients"
              value={formData.management.adviceToPatients}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="SafetyNet to provide"
              name="management.safetyNet"
              value={formData.management.safetyNet}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />
            <StyledTextField
              label="Further Reading"
              name="management.furtherReading"
              value={formData.management.furtherReading}
              onChange={handleChange}
              fullWidth
              // required
              multiline
              minRows={3} // Set the minimum number of rows
              maxRows={Infinity} // Allow it to grow indefinitely
            />

            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
              Submit
            </Button>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick={false}
              rtl={false}
              pauseOnFocusLoss={false}
              draggable={false}
              pauseOnHover={false}
              theme="colored"
              transition={Slide}
            />
          </Box>
          {/* <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignSelf="center"
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          >
            <StyledTextField
              id="outlined-basic"
              hiddenLabel
              size="small"
              variant="outlined"
              aria-label="Enter your email address"
              placeholder="Your email address"
              inputProps={{
                autocomplete: 'off',
                ariaLabel: 'Enter your email address',
              }}
            />
            <Button variant="contained" color="primary">
              Start now
            </Button>
          </Stack> */}
          {/* <Typography variant="caption" textAlign="center" sx={{ opacity: 0.8 }}>
            By clicking &quot;Start now&quot; you agree to our&nbsp;
            <Link href="#" color="primary">
              Terms & Conditions
            </Link>
            .
          </Typography> */}
        </Stack>
        {/* <Box
          id="image"
          sx={(theme) => ({
            mt: { xs: 8, sm: 10 },
            alignSelf: 'center',
            height: { xs: 200, sm: 700 },
            width: '100%',
            backgroundImage:
              theme.palette.mode === 'light'
                ? 'url("/static/images/templates/templates-images/hero-light.png")'
                : 'url("/static/images/templates/templates-images/hero-dark.png")',
            backgroundSize: 'cover',
            borderRadius: '10px',
            outline: '1px solid',
            outlineColor:
              theme.palette.mode === 'light'
                ? alpha('#BFCCD9', 0.5)
                : alpha('#9CCCFC', 0.1),
            boxShadow:
              theme.palette.mode === 'light'
                ? `0 0 12px 8px ${alpha('#9CCCFC', 0.2)}`
                : `0 0 24px 12px ${alpha('#033363', 0.2)}`,
          })}
        /> */}
      </Container>
    </Box>
  );
}

// const StyledInput = styled(Input)(
//   ({ theme }) => `

//   .${inputClasses.input} {
//     width: 100%;
//     font-family: 'IBM Plex Sans', sans-serif;
//     font-size: 0.875rem;
//     font-weight: 400;
//     line-height: 1.5;
//     padding: 8px 12px;
//     border-radius: 8px;
//     color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
//     background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
//     border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
//     box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

//     &:hover {
//       border-color: ${blue[400]};
//     }

//     &:focus {
//       outline: 0;
//       border-color: ${blue[400]};
//       box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
//     }
//   }
// `
// );

// const Label = styled(({ children, className }) => {
//   const formControlContext = useFormControlContext();
//   const [dirty, setDirty] = React.useState(false);

//   React.useEffect(() => {
//     if (formControlContext?.filled) {
//       setDirty(true);
//     }
//   }, [formControlContext]);

//   if (formControlContext === undefined) {
//     return <p>{children}</p>;
//   }

//   const { error, required, filled } = formControlContext;
//   const showRequiredError = dirty && required && !filled;

//   return (
//     <p className={clsx(className, error || showRequiredError ? 'invalid' : '')}>
//       {children}
//       {required ? ' *' : ''}
//     </p>
//   );
// })`
//   font-family: 'IBM Plex Sans', sans-serif;
//   font-size: 0.875rem;
//   margin-bottom: 4px;

//   &.invalid {
//     color: red;
//   }
// `;

// const HelperText = styled((props) => {
//   const formControlContext = useFormControlContext();
//   const [dirty, setDirty] = React.useState(false);

//   React.useEffect(() => {
//     if (formControlContext?.filled) {
//       setDirty(true);
//     }
//   }, [formControlContext]);

//   if (formControlContext === undefined) {
//     return null;
//   }

//   const { required, filled } = formControlContext;
//   const showRequiredError = dirty && required && !filled;

//   return showRequiredError ? <p {...props}>This field is required.</p> : null;
// })`
//   font-family: 'IBM Plex Sans', sans-serif;
//   font-size: 0.875rem;
// `;

const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  900: '#003A75'
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025'
};

const StyledTextField = styled(TextField)(
  ({ theme }) => `
    width: 100%; /* Make it full width */
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 7px; /* Adjust padding */


    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
      box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${blue[400]};
      }

      &:focus .MuiOutlinedInput-notchedOutline {
        border-color: ${blue[400]};
        box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
      }
    }

    /* Styles for the input */
    .MuiInputBase-input {
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }
`
);

const StyledSelect = styled(Select)(
  ({ theme }) => `
    width: 100%; /* Make it full width */
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;

    /* Style for the Select input */
    & .MuiSelect-select {
      border-radius: 8px;
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
      background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
      box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
      display: flex; /* Align placeholder text vertically */
      align-items: center;

      /* Add focus and hover styles */
      &:hover {
        border-color: ${blue[400]};
      }

      &:focus {
        outline: 0;
        border-color: ${blue[400]};
        box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
      }
    }

    /* Style for the Menu items */
    & .MuiMenuItem-root {
      font-family: 'IBM Plex Sans', sans-serif;
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }

    /* Style for the dropdown icon */
    & .MuiSelect-icon {
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }
`
);
